import { formatReportDate } from '../reports/formatting';

export { formatReportCurrency as formatMoney, formatReportDate as formatDate } from '../reports/formatting';

/** `Mar 3, 2026 – Mar 16, 2026` */
export function formatPeriod(start: string, end: string): string {
  return `${formatReportDate(start)} – ${formatReportDate(end)}`;
}

/** An ISO instant rendered in the viewer's locale, e.g. `Mar 30, 2026, 3:00 PM`. Unparseable input is shown unchanged. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
